import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  ...zhLocale,
  header: {
    currentLang: '多语言',
    title: '数字音乐管理平台',
    ai_title: '腾讯音乐启明星AI音频发布平台',
    home: '平台首页',
    profile: '用户中心',
    help: '帮助中心',
    about: '产品指引',
    login: '登录',
    logout: '退出',
    language: '语言切换',
  },
  account: {
    passwordLogin: '邮箱登录',
    phoneNumLogin: '手机号登录',
    emailPlaceholder: '请输入邮箱',
    passwordPlaceholder: '6 - 12位密码，区分大小写',
    phoneNumPlaceholder: '请输入手机号',
    codePlaceholder: '请输入验证码',
    sendCode: '发送验证码',
    reSend: '重新发送',
    nicknamePlaceholder: '请输入昵称',
    forgetPassword: '忘记密码',
    registerAccount: '注册账号',
    passwordAgainPlaceholder: '请再次输入密码',
    login: '登录',

    phoneNumError: '手机号格式错误，请输入11位手机号',
    codeError: '验证码错误，请输入6位验证码',

    register: '注册',
    registerCallback: '注册成功',
    username: '昵称',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',

    forgotPassword: '密码找回',
    forgotPasswordDesc: '请输入你需要找回登录密码的邮箱',
    submit: '提交',
    forgetSuccessMessage: '重置密码申请提交成功，请前往邮箱链接进行密码重置！',
    resetSuccessMessage: '密码重置成功，请直接登录！',

    resetPassword: '重置密码',
    emailValidPlaceholder: '请输入合法的邮箱',
    passwordValidPlaceholder: '6-12位，需要包含字母、数字、字符！',
    passwordAgainValidPlaceholder: '密码输入不一致，请重新输入',
    nicknameValidPlaceholder: '昵称不能超过10个字符',

    registerSuccess: '注册成功！',
    toLogin: '点击登录',

    registerSuccessMessage: '注册成功，请前往邮箱激活账号后登录',
    registerEmailUsed: '邮箱已经注册过，请直接登录',

    sendEmailError: '发送邮件失败',
    emailNotRegistered: '邮箱未被注册',
    overclock: '操作频率过高，请30分钟后再试',
    emailError: '邮箱格式非法',
    wrongPassword: '密码错误',
    inactive: '账号未激活，请去邮箱激活',
    pastDue: '邮件已过期，请重新发送邮件',
    invalidEmail: '无效的邮件',

    verifyCodeError: '验证码错误',
    sendCodeFailed: '发送验证码失败',
    phoneNumRegisterFailed: '手机号注册失败',
    shotPicVerifyCode: '命中图形验证码',
    phoneBound: '手机号已绑定',

    doneError: '操作失败',

    confirm: '确认'
  },
  home: {
    contentManage: '内容管理',
    contentManageDesc: '信息便捷管理 作品一键发布',
    selfPublish: '自助发行',
    selfPublishDesc: '一站式发行平台 轻松触达全球平台',
    dataService: '数据服务',
    dataServiceDesc: '可视化数据报表 实时掌握作品动态',
    cpProtect: '版权保护',
    cpProtectDesc: '在线权益申诉 及时洞察风险',
    fastSign: '便捷签约',
    fastSignDesc: '版权专业合作 助力内容发展',
    fastSettlement: '快速结算',
    fastSettlementDesc: '全方位作品结算数据 透明可见',
  },
  nav: {
    profile: '@:header.profile',
    basic: '用户资料',
    message: '消息通知',
    registry: '申请注册',

    contentManagement: '内容管理',
    trackManagement: '歌曲管理',
    albumManagement: '专辑管理',
    mvManagement: '视频管理',
    singerManagement: '艺人管理',
    contractManagement: '合同管理',

    modifyRecord: '字段修改记录',
    modifyTrack: '歌曲',
    modifyAlbum: '专辑',
    modifyMv: '视频',

    data: '数据管理',
    product: '作品数据',
    user: '用户数据',
    songlist: '歌单数据',

    income: '收入管理',
    settle: '结算管理',

    appeal: '版权申诉',
    history: '历史申诉',
    toAppeal: '版权申诉-编辑入口',
    appealEdit: '申诉编辑',
  },

  common: {
    search: '查询',
    export: '导出全部',
    modify: '修改',
    cancel: '取消',
    noResult: '很抱歉，未找到相关匹配数据。',
    empty: '暂无数据',

    singerName: '艺人名',
    singerNamePlaceholder: '请输入艺人名',
    status: '状态',
    statusPlaceholder: '请选择状态',
    contract: '合同编号',
    contractPlaceholder: '请输入合同编号',
    statusMap: {
      0: '全部',
      1: '待上架',
      2: '已下架',
      3: '审核中',
      4: '不通过',
      5: '已上架'
    },
    hiddenReasonMap: {
      0: '无',
      1: '无媒体文件',
      2: '重复上传',
      3: '音频异常',
      4: '网易总代理',
      5: '阿里总代理',
      6: '百度总代理',
      7: '普通无版权',
      8: '严重无版权',
      10: '文化部通报',
      11: '涉黄赌毒敏感',
      12: '待上线',
      13: '非正式',
      15: '其他',
      16: '版权到期',
      17: '版权到期(重点)',
      18: '版权诉讼'
    },
    hiddenTrack: '隐藏原因',
    hiddenTrackPlaceholder: '选择隐藏原因',
    upcPlaceholder: '请输入 UPC',
    relateCompany: '关联厂牌',
    publicTime: '发行时间',
    publicTimePlaceholder: '请选择发行时间',
    uploadTime: '上传时间',
    uploadTimePlaceholder: '请选择上传时间',

    flowStatus: {
      uploading: '平台上传物料',
      processing: '系统自动审核',
      manualChecking: '人工审核中',
      approved: '人工审核通过',
      rejected: '人工审核不通过',
      warehousing: '曲库入库',
      pending: '曲库待上架',
      online: '曲库已上架',
      takeDown: '曲库已下架',
      platform: '平台状态'
    }
  },

  const: {
    isOnlyMap: {
      0: '非总代理',
      1: '总代理',
    },
    isAgentMap: {
      0: '自有',
      1: '代理'
    },
    canLegalRightsMap: {
      0: '否',
      1: '是',
    },
    paymentMap: {
      1: '免费',
      3: '1.0模式',
      5: '2.0模式',
      10: '3.0模式',
    },

  },

  person: {
    edit: '更新信息',
    basic: '基本信息',
    registryInfo: '本平台仅支持TME合约厂牌使用，非合约厂牌请使用腾讯音乐人开放平台',
    partner: '合约厂牌',
    notPartner: '非合约厂牌',
    role: '身份类型',
    isSign: '是否签约',
    production: '作品信息',
    companyName: '公司名称',
    namePlaceholder: '请填写公司名称',
    legalPerson: '法人代表',
    legalPersonPlaceholder: '需与营业执照信息一致',
    email: '联系人邮箱',
    emailPlaceholder: '请填写正确邮箱格式,示例：xxx@example.com',
    address: '联系人地址',
    addressPlaceholder: '请填写联系人地址信息',
    phone: '联系人电话',
    phonePlaceholder: '请填写联系人电话信息',
    qq: 'QQ号码',
    qqPlaceholder: '请填写联系人QQ号码信息',
    license: '公司营业执照',
    desc: '公司简介',
    logo: '公司Logo',
    cpCompany: '版权所属厂牌',
    cpCompanyPlaceholder: '请填写版权所属厂牌',
    agentCompany: '代理厂牌',
    agentCompanyTooltip: '用于母公司查看旗下代理的相关子厂牌上传内容情况（旗下无代理厂牌请勿填写，以免影资质审核）',

    nameRule: '请填写公司名',
    photoRule: '只能上传jpg/png文件',
    phtotRule2: '需加盖公章',
    logoRule: '@:person.photoRule',
    corporationRule: '请输入法人代表',

    profileAuditing: '资料审核中',
    profileReject: '审核不通过',
    checked: '审核通过',

    roleMap: {
      1: '厂牌',
      2: '商务',
      3: '法务',
      4: '编务',
      5: '其他',
      6: '财经',
      7: '个人',
      8: '公司',
      9: 'AI发行'
    },

    personHome: '用户首页'
  },

  track: {
    trackName: '歌曲名',
    trackNamePlaceholder: '请输入歌曲名称',
    precise: '精确搜索',
    fuzzy: '模糊搜索',
    isrcPlaceholder: '请输入ISRC',
    exclusivity: '录音授权形式',
    exclusivityPlaceholder: '请选择授权形式',
    licensorRole: '录音授权关系',
    licensorRolePlaceholder: '请选择授权关系',
    wmExclusivity: '词曲可维权',
    wmExclusivityPlaceholder: '请选择是否可维权',
    paymentMode: '付费模式',
    paymentModePlaceholder: '请选择付费模式',
    version: '版本',
    trackId: '歌曲ID',
    trackIdPlaceholder: '多个以逗号分隔',

    showFlow: '分发进度'
  },

  album: {
    create: '新建专辑',
    searchError: '专辑查询异常',

    albumName: '专辑名',
    albumNamePlaceholder: '请输入专辑名',
    albumId: '专辑ID',
    albumIdPlaceholder: '多个以逗号分隔',

    sendMail: '发送平台邮件',
    sendMailSuccess: '发送平台邮件成功',
    showFlow: '分发进度'
  },

  mv: {
    mvName: '视频名',
    mvNamePlaceholder: '请输入视频名',
    create: '新建视频',
    preview: '预览',
  },

  singer: {
    type: '类型',
    typePlaceholder: '全部',
    create: '新建艺人',
    twoNewestAlbum: '最近两张专辑信息',
    singerTypeMap: {
      0: '男',
      1: '女',
      2: '组合',
      3: '其他',
      5: '虚拟'
    }
  },

  modify: {
    applyUser: '提交用户',
    applyUserPlaceholder: '输入提交用户(厂牌名)搜索',
    auditTime: '审核时间',
    auditTimePlaceholder: '选择审核时间搜索',
    insertTime: '提交时间',
    insertTimePlaceholder: '选择提交时间搜索',
    status: '状态',
    statusMap: {
      0: '未审核',
      1: '取消',
      2: '通过',
      3: '不通过',
      4: '审核中'
    },
    auditor: '审核人',
    before: '修改前',
    after: '修改后',
  },

  data: {
    descTME: '统计范围：仅限于通过TME数字音乐管理平台上传的作品',
    descAppend: '流量数据为运营口径实时数据，一切结算有效播放以财经结算报为准',
    descAll: '统计范围：旗下所有有权利作品',
    tabs: {
      perform: '作品表现',
      apply: '作品应用'
    },
    perform: {
      track: '上传歌曲',
      album: '上传专辑',
      mv: '上传视频',
      singer: '上传艺人',
      uploadingOverview: '上传作品情况',
      productOverview: '作品数据情况',
      cycleMap: {
        '-9999': '近两年',
        '-7': '近一周',
        '-30': '近一月'
      },
      streams: '歌曲播放指数',
      downloads: '歌曲下载指数',

      paymentOverview: '上传作品版权付费分布情况',
      paymentDesc: '点击饼图可查看播放份额',

      isAgentN: '自有歌曲',
      isAgentY: '代理歌曲',
      isOnlyN: '非总代理歌曲',
      isOnlyY: '总代理歌曲',
      canLegalRightsY: '词曲可维权歌曲',
      canLegalRightsN: '不可维权歌曲',
      free: '免费歌曲',
      payment: '付费歌曲'
    },

    apply: {
      platform: '平台',
      platformMap: {
        tme: '全部平台',
        qq: 'QQ音乐',
        kg: '酷狗音乐',
        kw: '酷我音乐'
      },
      hottest: '最热',
      newest: '最新',
      increase: '升幅',
      decrease: '降幅',

      no: '序号',
      trackInfo: '歌曲信息',
      version: '歌曲版本',
      language: '语言',

      streamsAndIndex: '播放量(指数)',
      downloadsAndIndex: '下载量(指数)',
      favoritesAndIndex: '收藏量(指数)',

      streamsIndex: '播放指数',
      downloadsIndex: '下载指数',
      favoritesIndex: '收藏指数',

      streams: '播放量',
      downloads: '下载量',
      favorites: '收藏量',

      remarks: '评论数',
      remarksIncrease: '评论增长指数',
      trend: '趋势图',
      qqRank: 'Q音热歌榜最佳排名',
      kugouRank: '酷狗Top500榜最佳排名',

      interval: '数据周期',
      to: '至'

    },

    fans: {
      total: '总收听用户数',
      yesterday: '昨日收听用户数',
      terminal: '用户终端',
      gender: '用户性别',
      area: '用户地域',
      top: '用户城市排名 TOP10',
      移动端: '移动端',
      PC端: 'PC端',
      男生: '男生',
      女生: '女生'
    }
  },

  appeal: {
    cpTitle: '版权歌曲',
    appealTitle: '申诉歌曲',
    downloadTemplate: '批量查询模板',
    batchSearch: '批量查询',
    batchLink: '链接解析'
  },

  cpTask: {
    cpTaskTitle: '版权入库任务',
    cpTaskListTitle: '版权入库任务列表',
    cpTaskDetailTitle: '版权入库任务详情',
    taskId: '任务ID',
    taskIdPlaceholder: '多个ID逗号分隔',
    taskName: '任务名称',
    taskNamePlaceholder: '请输入任务名称，模糊搜索',
    buyId: '采买任务ID',
    buyIdPlaceholder: '多个ID逗号分隔',
    contentType: '组别',
    contentTypePlaceholder: '请选择组别',
    buyType: '采买类型',
    buyTypePlaceholder: '请选择采买类型',
    reviewStatus: '版权状态',
    reviewStatusPlaceholder: '请选择版权状态',
    status: '入库状态',
    statusPlaceholder: '请选择入库状态',
    businessBroker: '商务负责人',
    businessBrokerPlaceholder: '请选择商务负责人',

    createTask: '新建上架任务',
    editTask: '编辑',
    detailTask: '详情',
    findTracks: '歌曲',
    exportTracks: '导出',
    stopTask: '停用',
    runTask: '启用',
  },

  aiContent: {
    title: 'AI内容管理',
    trackManagement: '歌曲管理',

    modifyRecord: '字段修改记录',
    modifyTrack: '歌曲',
  },

  message: '你好 i18n !!'
}
